export default __webpack_public_path__ + "static/flutter-bahrain-390a9273fc8d9ad1a2b2745439e78c66.webp";